import { render, staticRenderFns } from "./MailVerify.vue?vue&type=template&id=754e4762"
import script from "./MailVerify.vue?vue&type=script&lang=js"
export * from "./MailVerify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports